import { Switch } from 'antd';
import { FC } from 'react';

import s from './index.module.scss';

interface ISwitchButtonProps {
	label: string;
	onClick: (value: boolean) => void;
	loading: boolean;
	checked: boolean;
}
export const SwitchButton: FC<ISwitchButtonProps> = ({ label, onClick, loading, checked }) => {
	return (
		<div className={s.root}>
			<div className={s.label}>{label}</div>
			<Switch loading={loading} checked={checked} onClick={onClick} />
		</div>
	);
};
